<template>
    <div id="app" >
         
        <h3> Hierarchy: {{  (data.hier_name) }} </h3>
     
      <TreeChart
        :json="data"
        :md="md"
        :parent_version="parentVersion"
        :allow_data="allow_data"
        :class="{ landscape: landscape.length }"
        @click-node="clickNode"
      />
    </div>
  </template>
  
  <script>
  import TreeChart from "./TreeChart.vue"
  export default {
    name: "app",
    components: {
      TreeChart,
    },
    props: { 
      parentVersion: {
        required: true,
        type: Array,
        default: () => [],
      },
     
     md: {
       required: true,
       type: Boolean,
       default: true,
     },
     data: {
        required: true,
        type: [Object, String],
        default: 0,
      },
    allow_data:{
      type: Boolean,
      default:true
    }
    },
    data() {
      return {
        landscape: [],
      }
    },
    methods: {
      clickNode: function (node) {
        // eslint-disable-next-line
        console.log(node);
      },
    },
  };
  </script>
  
  <style>
  #app {
    font-family:inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    overflow-x: scroll;
  }
  #app .avat {
    border-radius: 2em;
    border-width: 2px;
  }
  #app .name {
    font-weight: 700;
  }
  #app .rootNode .name {
    color: red;
  }
  .foot {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #333;
    padding: 24px;
    overflow: hidden;
    color: #999;
    font-size: 14px;
    text-align: center;
  }
  .foot a {
    color: #fff;
    margin: 0 0.5em;
  }
  </style>